module.exports = __webpack_public_path__ + "img/tsinghua.251b2bed.png";